export const errorLogin = (error) => {
    let errorMessage = "An error occurred. Please try again.";

    switch (error.code) {
        case "auth/user-not-found":
            return errorMessage = "Email not found. Please sign up to create an account.";
        case "auth/wrong-password":
            return errorMessage = "Incorrect password. Please try again.";
        case "auth/invalid-email":
            return errorMessage = "Invalid email format.";
        case "auth/user-disabled":
            return errorMessage = "This account has been disabled.";
        case "auth/missing-password":
            return errorMessage = "Password not set for this account. Please click 'Forgot Password' to generate your password.";
        case "auth/account-exists-with-different-credential":
            return errorMessage = "Account exists with different credential.";
        case "auth/invalid-credential":
            return errorMessage = "Invalid credential";
        case "auth/invalid-app-credential":
            return errorMessage = "Invalid app credential";
        case "auth/too-many-requests":
            return errorMessage = "Too many requests, please try after sometimes";
        case "auth/captcha-check-failed":
            return errorMessage = "Hostname match not found";
        case "Hostname match not found (auth/captcha-check-failed)":
            return errorMessage = "Hostname match not found";

        default:
            return errorMessage = error.message;
    }
}
